import React from 'react'

// Outline icon set matching the reference design system (lucide, 24x24, 2px stroke).
const base = {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
}

const icon = (paths) => ({ style, ...rest }) => (
    <svg {...base} style={{ width: 16, height: 16, flexShrink: 0, ...style }} {...rest}>
        {paths}
    </svg>
)

export const ExternalLinkIcon = icon(<>
    <path d="M15 3h6v6M10 14 21 3" />
    <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
</>)

export const FolderOpenIcon = icon(<>
    <path d="M3 17V5a2 2 0 0 1 2-2h4l2 3h8a2 2 0 0 1 2 2v2" />
    <path d="M5 10h16a1 1 0 0 1 1 1.3l-3 8a1 1 0 0 1-1 .7H4a2 2 0 0 1-2-2l2-7a1 1 0 0 1 1-1Z" />
</>)

export const LayoutDashboardIcon = icon(<>
    <rect width="7" height="9" x="3" y="3" rx="1" />
    <rect width="7" height="5" x="14" y="3" rx="1" />
    <rect width="7" height="9" x="14" y="12" rx="1" />
    <rect width="7" height="5" x="3" y="16" rx="1" />
</>)

export const BriefcaseIcon = icon(<>
    <rect x="3" y="7" width="18" height="14" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12a20 20 0 0 0 18 0M12 11v4" />
</>)

export const BuildingIcon = icon(<>
    <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
    <path d="M9 22v-4h6v4M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01" />
</>)

export const ListChecksIcon = icon(<>
    <path d="m3 17 2 2 4-4M3 7l2 2 4-4M13 6h8M13 12h8M13 18h8" />
</>)

export const Building2Icon = icon(<>
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2M10 6h4M10 10h4M10 14h4M10 18h4" />
</>)

export const UsersIcon = icon(<>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    <circle cx="9" cy="7" r="4" />
</>)

export const UserPlusIcon = icon(<>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8v6M22 11h-6" />
</>)

export const BoxesIcon = icon(<>
    <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z" />
    <path d="m7 16.5-4.74-2.85M7 16.5l5-3M7 16.5v5.17M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z" />
    <path d="m17 16.5-5-3M17 16.5l4.74-2.85M17 16.5v5.17M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z" />
    <path d="M12 8 7.26 5.15M12 8l4.74-2.85M12 13.5V8" />
</>)

export const ReceiptIcon = icon(<>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 17.5v-11" />
</>)

export const ClipboardListIcon = icon(<>
    <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M12 11h4M12 16h4M8 11h.01M8 16h.01" />
</>)

export const ClockIcon = icon(<>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
</>)

export const FileTextIcon = icon(<>
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4M16 13H8M16 17H8M10 9H8" />
</>)

export const EyeIcon = icon(<>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
</>)

export const CalendarIcon = icon(<>
    <path d="M8 2v4M16 2v4M3 10h18" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
</>)

export const PlusIcon = icon(<>
    <path d="M5 12h14M12 5v14" />
</>)

export const CheckIcon = icon(<>
    <path d="m5 12 4 4L19 6" />
</>)

export const CopyIcon = icon(<>
    <rect width="14" height="14" x="8" y="8" rx="2" />
    <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
</>)

export const MailIcon = icon(<>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-10 6L2 7" />
</>)

export const KeyIcon = icon(<>
    <circle cx="7.5" cy="15.5" r="4.5" />
    <path d="m10.7 12.3 8.8-8.8M15 8l2 2M17 6l2 2" />
</>)

export const ResetIcon = icon(<>
    <path d="M20 7v5h-5" />
    <path d="M4 17v-5h5" />
    <path d="M6.1 9a7 7 0 0 1 11.8-2L20 9" />
    <path d="M17.9 15a7 7 0 0 1-11.8 2L4 15" />
</>)

export const LockIcon = icon(<>
    <rect width="16" height="11" x="4" y="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    <path d="M12 14v3" />
</>)

export const PasswordIcon = icon(<>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    <circle cx="12" cy="10" r="1.5" />
    <path d="M12 11.5V15" />
</>)

export const PaidIcon = icon(<>
    <path d="M17 7h-6.5a3.5 3.5 0 0 0 0 7h3a3.5 3.5 0 0 1 0 7H7" />
    <path d="M12 3v4M12 21v-4" />
</>)

export const TrashIcon = icon(<>
    <path d="M3 6h18M8 6V4h8v2M19 6l-1 15H6L5 6M10 11v6M14 11v6" />
</>)

export const ArchiveIcon = icon(<>
    <rect width="18" height="5" x="3" y="3" rx="1" />
    <path d="M5 8v12h14V8M10 12h4" />
</>)

export const PhoneIcon = icon(<>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.74a16 16 0 0 0 6 6l1.28-1.28a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.63.62A2 2 0 0 1 22 16.92Z" />
</>)

export const MessageSquareIcon = icon(<>
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z" />
</>)

export const SmsIcon = icon(<>
    <path d="M21 11.5a4.5 4.5 0 0 1-4.5 4.5H13l-4 3v-3H7.5A4.5 4.5 0 0 1 3 11.5v-4A4.5 4.5 0 0 1 7.5 3h9A4.5 4.5 0 0 1 21 7.5Z" />
    <path d="M8 8h8M8 12h5" />
</>)

export const SaveIcon = icon(<>
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z" />
    <path d="M17 21v-8H7v8M7 3v5h8" />
</>)

export const DownloadIcon = icon(<>
    <path d="M12 3v12M7 10l5 5 5-5" />
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
</>)

export const EditIcon = icon(<>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />
</>)

export const MapPinIcon = icon(<>
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
</>)

export const SearchIcon = icon(<>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
</>)

export const VerifiedIcon = icon(<>
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
</>)

export const ChevronDownIcon = icon(<>
    <path d="m6 9 6 6 6-6" />
</>)

export const ChevronRightIcon = icon(<>
    <path d="m9 18 6-6-6-6" />
</>)

export const AlertTriangleIcon = icon(<>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4M12 17h.01" />
</>)

export const AlertCircleIcon = icon(<>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 8v4M12 16h.01" />
</>)

export const LogOutIcon = icon(<>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
</>)

export const MenuIcon = icon(<>
    <path d="M4 6h16M4 12h16M4 18h16" />
</>)

export const XIcon = icon(<>
    <path d="M18 6 6 18M6 6l12 12" />
</>)

export const SettingsIcon = icon(<>
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
</>)

export const HardHatIcon = icon(<>
    <path d="M10 10V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6" />
    <path d="M4 15v-3a8 8 0 0 1 6-7.75M14 4.25A8 8 0 0 1 20 12v3" />
    <rect x="2" y="15" width="20" height="5" rx="2" />
</>)
